/* eslint-disable max-len */

// hwi_oauth_service_redirect
export const HWI_OAUTH_SERVICE_REDIRECT = '/redirect/{service}';
// checkout.klarna.session.token
export const CHECKOUT_KLARNA_SESSION_TOKEN = '/{store}/{language}/checkout/klarna/session';
// checkout.klarna.complete
export const CHECKOUT_KLARNA_COMPLETE = '/{store}/{language}/checkout/klarna/complete';
// checkout.adyen_v3.payment
export const CHECKOUT_ADYEN_V3_PAYMENT = '/{store}/{language}/checkout/adyen/payment_v3';
// checkout.adyen_v3.fetch_payment_details
export const CHECKOUT_ADYEN_V3_FETCH_PAYMENT_DETAILS = '/{store}/{language}/checkout/adyen/fetch-details';
// checkout.booztpay.authorize
export const CHECKOUT_BOOZTPAY_AUTHORIZE = '/{store}/{language}/checkout/booztpay/authorize';
// articles.json
export const ARTICLES_JSON = '/{store}/{language}/articles/{ids}';
// product.dynamic_sizeguide
export const PRODUCT_DYNAMIC_SIZEGUIDE = '/{store}/{language}/dynamic-sizeguide/{productId}';
// product.size_guide_json
export const PRODUCT_SIZE_GUIDE_JSON = '/{store}/{language}/size-guide-json/{productId}';
// product.brand.groups
export const PRODUCT_BRAND_GROUPS = '/{store}/{language}/brandgroups/{brandGroupId}/brands';
// product.brand.groupsmulti
export const PRODUCT_BRAND_GROUPSMULTI = '/{store}/{language}/brandgroupsmulti/{brandGroupIds}/brands';
// product.view.ean
export const PRODUCT_VIEW_EAN = '/{store}/{language}/product-data/{productId}';
// product.api.product.feed
export const PRODUCT_API_PRODUCT_FEED = '/{store}/{language}/api/product/feed/{variantId}';
// product.api.product.feed_type
export const PRODUCT_API_PRODUCT_FEED_TYPE = '/{store}/{language}/api/product/feed/{variantId}/{type}';
// product.api.product.carousel
export const PRODUCT_API_PRODUCT_CAROUSEL = '/{store}/{language}/api/navigation/{navigationId}/carousel';
// customer.visitor.new
export const CUSTOMER_VISITOR_NEW = '/visitor';
// customer.customer_account_action.request_to_delete
export const CUSTOMER_CUSTOMER_ACCOUNT_ACTION_REQUEST_TO_DELETE = '/{store}/{language}/request-to-delete-personal-data';
// customer.customer_account_action.verify_request_to_delete
export const CUSTOMER_CUSTOMER_ACCOUNT_ACTION_VERIFY_REQUEST_TO_DELETE = '/{store}/{language}/verify-request-to-delete-personal-data';
// customer.customer_account_action.request_to_export
export const CUSTOMER_CUSTOMER_ACCOUNT_ACTION_REQUEST_TO_EXPORT = '/{store}/{language}/request-to-export-personal-data';
// customer.customer_account_action.verify_request_to_export
export const CUSTOMER_CUSTOMER_ACCOUNT_ACTION_VERIFY_REQUEST_TO_EXPORT = '/{store}/{language}/verify-request-to-export-personal-data';
// api.customer.deals_list
export const API_CUSTOMER_DEALS_LIST = '/{store}/{language}/api/customer/deals/activated';
// review.score
export const REVIEW_SCORE = '/{store}/{language}/score/{source}/{itemId}';
// review.checkout.score
export const REVIEW_CHECKOUT_SCORE = '/{store}/{language}/checkout/score/{source}/{itemId}';
// newsletter.unsubscribe
export const NEWSLETTER_UNSUBSCRIBE = '/{store}/{language}/newsletter/unsubscribe';
// newsletter.form
export const NEWSLETTER_FORM = '/{store}/{language}/newsletter';
// subscription.set_subscription_cookies
export const SUBSCRIPTION_SET_SUBSCRIPTION_COOKIES = '/{store}/{language}/marketing/subscription/newsletter';
// subscripton.remove_subscription_cookies
export const SUBSCRIPTON_REMOVE_SUBSCRIPTION_COOKIES = '/{store}/{language}/marketing/subscription/newsletter';
// navigation.load_json
export const NAVIGATION_LOAD_JSON = '/{store}/{language}/navigation_json';
// recent-products.delete
export const RECENT_PRODUCTS_DELETE = '/{store}/{language}/api/me/recents';
// recent-product.delete
export const RECENT_PRODUCT_DELETE = '/{store}/{language}/recent-products/{variantIds}';
// recent.product.filters
export const RECENT_PRODUCT_FILTERS = '/{store}/{language}/api/recents-filters';
// search.autocomplete
export const SEARCH_AUTOCOMPLETE = '/{store}/{language}/search/ac';
// search.result
export const SEARCH_RESULT = '/{store}/{language}/search/result';
// api.search.ac
export const API_SEARCH_AC = '/{store}/{language}/api/search/ac';
// api.search.suggestions
export const API_SEARCH_SUGGESTIONS = '/{store}/{language}/api/search/suggestions';
// api.search.result.facets
export const API_SEARCH_RESULT_PAGE = '/{store}/{language}/api/search/result';
// api.personalization.sizehistory
export const API_PERSONALIZATION_SIZEHISTORY = '/{store}/{language}/api/personalization/sizehistory/{mainCategoryId}/{brandId}/{productId}';
// api.personalization.customer_based_sizeadvice
export const API_PERSONALIZATION_CUSTOMER_BASED_SIZEADVICE = '/{store}/{language}/api/personalization/customer-size-advice/{categoryId}/{brandId}/{sizesAvailable}/{productId}';
// brandaz.page_filter
export const BRANDAZ_PAGE_FILTER = '/{store}/{language}/brands-a-z/{brandAZFilter}';
// api.core.contact_us
export const API_CORE_CONTACT_US = '/{store}/{language}/api/contact-us';
// api.store.localization
export const API_STORE_LOCALIZATION = '/{store}/{language}/api/store/localization';
// api.navigation.myboozt_menu
export const API_NAVIGATION_MYBOOZT_MENU = '/{store}/{language}/api/navigation-menu/myboozt';
// api.navigation.breadcrumbs
export const API_NAVIGATION_BREADCRUMBS = '/{store}/{language}/api/navigation/{navigationId}/breadcrumbs';
// api.favorite.favorites.list
export const API_FAVORITE_FAVORITES_LIST = '/{store}/{language}/api/me/favorites';
// api.favorite.product.add
export const API_FAVORITE_PRODUCT_ADD = '/{store}/{language}/api/me/favorites';
// api.favorite.product.remove
export const API_FAVORITE_PRODUCT_REMOVE = '/{store}/{language}/api/me/favorites';
// api.favorite.brand.list_favorite_json
export const API_FAVORITE_BRAND_LIST_FAVORITE_JSON = '/{store}/{language}/api/favorite/brand/favorite_json/{visitorId}/{timestamp}';
// api.favorite.brand.add
export const API_FAVORITE_BRAND_ADD = '/api/favorite-brands/{brandId}/gender/{gender}';
// api.favorite.brand.remove
export const API_FAVORITE_BRAND_REMOVE = '/api/favorite-brands/{brandId}/gender/{gender}';
// api.favorite.brand.remove.all
export const API_FAVORITE_BRAND_REMOVE_ALL = '/api/favorite/brand';
// api.favorite-products.filters
export const API_FAVORITE_PRODUCTS_FILTERS = '/{store}/{language}/api/favorites-filters';
// api.favorite.collection.get
export const API_FAVORITE_COLLECTION_GET = '/{store}/{language}/api/me/collections/{id}';
// api.favorite.collection.shared.get
export const API_FAVORITE_COLLECTION_SHARED_GET = '/{store}/{language}/api/me/shared-collections/{urlHash}';
// api.favorite.collection.list
export const API_FAVORITE_COLLECTION_LIST = '/{store}/{language}/api/me/collections';
// api.favorite.collection.patch
export const API_FAVORITE_COLLECTION_PATCH = '/{store}/{language}/api/me/collections/{id}';
// api.favorite.collection.delete
export const API_FAVORITE_COLLECTION_DELETE = '/{store}/{language}/api/me/collections/{id}';
// api.favorite.collection.items.add
export const API_FAVORITE_COLLECTION_ITEMS_ADD = '/{store}/{language}/api/me/collections/{id}/items';
// api.favorite.collection.items.delete_bulk
export const API_FAVORITE_COLLECTION_ITEMS_DELETE_BULK = '/{store}/{language}/api/me/collections/{id}/deleted-items';
// api.favorite.collection.delete_bulk
export const API_FAVORITE_COLLECTION_DELETE_BULK = '/{store}/{language}/api/me/deleted-collections';
// api.favorite.collection.filters.get
export const API_FAVORITE_COLLECTION_FILTERS_GET = '/{store}/{language}/api/me/collections/{id}/filters';
// api.customer.login
export const API_CUSTOMER_LOGIN = '/api/login';
// api.customer.logout
export const API_CUSTOMER_LOGOUT = '/api/customer/logout';
// api.customer.orders
export const API_CUSTOMER_ORDERS = '/{store}/{language}/api/customer/orders';
// api.order.invoice
export const API_ORDER_INVOICE = '/{store}/{language}/api/orders/{orderId}/invoice';
// api.order.with_returns
export const API_ORDER_WITH_RETURNS = '/{store}/{language}/api/orders/with-returns';
// api.order.returns
export const API_ORDER_RETURNS = '/{store}/{language}/api/customer/returns';
// api.order.return
export const API_ORDER_RETURN = '/{store}/{language}/api/customer/returns/{uuid}';
// api.giftcard.merge
export const API_GIFTCARD_MERGE = '/{store}/{language}/api/giftcard/merge';
// api.giftcard.watchlist.add
export const API_GIFTCARD_WATCHLIST_ADD = '/{store}/{language}/api/giftcard/watchlist/add';
// api.order.gift.add
export const API_ORDER_GIFT_ADD = '/{store}/{language}/api/orders/{orderId}/gift-receipt';
// api.customer.customer_gift_cards_list
export const API_CUSTOMER_CUSTOMER_GIFT_CARDS_LIST = '/{store}/{language}/api/customer/gift-cards';
// api.customer.info
export const API_CUSTOMER_INFO = '/{store}/{language}/api/customer';
// api.order.return.list
export const API_ORDER_RETURN_LIST = '/{store}/{language}/api/order/gift/return/list/{slipUuid}';
// api.orders.gift.return
export const API_ORDERS_GIFT_RETURN = '/{store}/{language}/api/order/gift-return';
// api.orders.return
export const API_ORDERS_RETURN = '/{store}/{language}/api/order/return';
// api.customer.create_order_claim
export const API_CUSTOMER_CREATE_ORDER_CLAIM = '/{store}/{language}/api/order/claim';
// api.customer.profile.email.change
export const API_CUSTOMER_PROFILE_EMAIL_CHANGE = '/{store}/{language}/api/customer/profile/email/change';
// api.customer.email_change.confirm
export const API_CUSTOMER_EMAIL_CHANGE_CONFIRM = '/{store}/{language}/api/customer/email/confirm/{token}';
// api.customer.account_action
export const API_CUSTOMER_ACCOUNT_ACTION = '/{store}/{language}/api/customer/account-action/{type}';
// api.customer.product_notification.register
export const API_CUSTOMER_PRODUCT_NOTIFICATION_REGISTER = '/{store}/{language}/api/product-notification/{type}';
// api.customer.create
export const API_CUSTOMER_CREATE = '/{store}/{language}/api/customer/create';
// api.customer.email_verification.send_email
export const API_CUSTOMER_EMAIL_VERIFICATION_SEND_EMAIL = '/{store}/{language}/api/customer/email-verification/send-email';
// api.customer.forgot_password
export const API_CUSTOMER_FORGOT_PASSWORD = '/{store}/{language}/api/customer/forgot-password';
// api.customer.reset_password
export const API_CUSTOMER_RESET_PASSWORD = '/{store}/{language}/api/customer/reset-password';
// api.customer.customer_invoices_list
export const API_CUSTOMER_CUSTOMER_INVOICES_LIST = '/{store}/{language}/api/customer/invoices';
// api.customer.customer_detailed_invoice
export const API_CUSTOMER_CUSTOMER_DETAILED_INVOICE = '/{store}/{language}/api/customer/invoice/{invoiceId}';
// api.customer.customer_detailed_order_invoice
export const API_CUSTOMER_CUSTOMER_DETAILED_ORDER_INVOICE = '/{store}/{language}/api/customer/invoice/order/{orderId}';
// api.customer.customer_detailed_account
export const API_CUSTOMER_CUSTOMER_DETAILED_ACCOUNT = '/{store}/{language}/api/customer/account';
// api.customer.postpone_invoice
export const API_CUSTOMER_POSTPONE_INVOICE = '/{store}/{language}/api/customer/invoice/postpone/{invoiceId}';
// api.customer.invoice_payment_token
export const API_CUSTOMER_INVOICE_PAYMENT_TOKEN = '/{store}/{language}/api/customer/invoice/payment-token/{invoiceId}';
// api.customer.account_payment_token
export const API_CUSTOMER_ACCOUNT_PAYMENT_TOKEN = '/{store}/{language}/api/customer/account/payment-token/{accountId}';
// api.customer.booztpay_payment
export const API_CUSTOMER_BOOZTPAY_PAYMENT = '/{store}/{language}/api/customer/booztpay/payment/{type}/{id}';
// api.order.return_reason_list
export const API_ORDER_RETURN_REASON_LIST = '/{store}/{language}/api/order/return-reasons';
// api.customer.files_upload
export const API_CUSTOMER_FILES_UPLOAD = '/{store}/{language}/api/customer/files';
// api.customer.files_delete
export const API_CUSTOMER_FILES_DELETE = '/{store}/{language}/api/customer/files';
// api.customer.password_create
export const API_CUSTOMER_PASSWORD_CREATE = '/{store}/{language}/api/customer/password';
// api.customer.password_change
export const API_CUSTOMER_PASSWORD_CHANGE = '/{store}/{language}/api/customer/password';
// api.customer.gender_update
export const API_CUSTOMER_GENDER_UPDATE = '/{store}/{language}/api/customer/gender';
// api.customer.billing_phone_update
export const API_CUSTOMER_BILLING_PHONE_UPDATE = '/{store}/{language}/api/customer/billing-phone';
// api.customer.order.cancel
export const API_CUSTOMER_ORDER_CANCEL = '/{store}/{language}/api/customer/order/cancellation';
// api.customer.birthday.update
export const API_CUSTOMER_BIRTHDAY_UPDATE = '/{store}/{language}/api/customer/birthday';
// api.customer.children.update
export const API_CUSTOMER_CHILDREN_UPDATE = '/{store}/{language}/api/customer/children';
// api.customer.update
export const API_CUSTOMER_UPDATE = '/{store}/{language}/api/customer';
// api.customer.live_chat.restore_id.save
export const API_CUSTOMER_LIVE_CHAT_RESTORE_ID_SAVE = '/{store}/{language}/api/customer/live-chat/restore-id';
// api.customer.live_chat.restore_id.get
export const API_CUSTOMER_LIVE_CHAT_RESTORE_ID_GET = '/{store}/{language}/api/customer/live-chat/restore-id';
// api.customer.club.sign_up
export const API_CUSTOMER_CLUB_SIGN_UP = '/{store}/{language}/api/customer/club/sign-up';
// api.club.sign_up.config
export const API_CLUB_SIGN_UP_CONFIG = '/{store}/{language}/api/club/sign-up/config';
// api.customer.club.deactivate
export const API_CUSTOMER_CLUB_DEACTIVATE = '/{store}/{language}/api/customer/club/deactivate';
// api.customer.club
export const API_CUSTOMER_CLUB = '/{store}/{language}/api/customer/club';
// api.customer.club.my_club
export const API_CUSTOMER_CLUB_MY_CLUB = '/{store}/{language}/api/customer/club/my-club';
// api.customer.club.boozters
export const API_CUSTOMER_CLUB_BOOZTERS = '/{store}/{language}/api/customer/club/boozters';
// api.customer.club.upgrade
export const API_CUSTOMER_CLUB_UPGRADE = '/{store}/{language}/api/customer/club/upgrade';
// api.customer.club.subscription.payment_method
export const API_CUSTOMER_CLUB_SUBSCRIPTION_PAYMENT_METHOD = '/{store}/{language}/api/customer/club/subscription/payment-method';
// api.customer.club.subscription.invoices
export const API_CUSTOMER_CLUB_SUBSCRIPTION_INVOICES = '/{store}/{language}/api/customer/club/subscription/invoices';
// api.customer.club.subscription
export const API_CUSTOMER_CLUB_SUBSCRIPTION = '/{store}/{language}/api/customer/club/subscription';
// api.customer.club.boozter_remove
export const API_CUSTOMER_CLUB_BOOZTER_REMOVE = '/{store}/{language}/api/customer/club/boozter/{id}';
// api.customer.club.ean_boozters
export const API_CUSTOMER_CLUB_EAN_BOOZTERS = '/{store}/{language}/api/customer/club/ean-boozters/{eanId}';
// api.club.ean_all_boozters
export const API_CLUB_EAN_ALL_BOOZTERS = '/{store}/{language}/api/club/ean-all-boozters/{eanId}';
// api.customer.club.about
export const API_CUSTOMER_CLUB_ABOUT = '/{store}/{language}/api/customer/club/about';
// api.customer.club.about_points
export const API_CUSTOMER_CLUB_ABOUT_POINTS = '/{store}/{language}/api/customer/club/about-points';
// api.customer.order.club.redeem_points
export const API_CUSTOMER_ORDER_CLUB_REDEEM_POINTS = '/{store}/{language}/api/customer/order/{order}/club/points';
// api.customer.club.subscription.create
export const API_CUSTOMER_CLUB_SUBSCRIPTION_CREATE = '/{store}/{language}/api/customer/club/subscription';
// api.customer.club.subscription.cancel
export const API_CUSTOMER_CLUB_SUBSCRIPTION_CANCEL = '/{store}/{language}/api/customer/club/subscription/cancellation';
// api.review.product_reviews
export const API_REVIEW_PRODUCT_REVIEWS = '/{store}/{language}/product-reviews/{productId}';
// api.review.product_review_summary
export const API_REVIEW_PRODUCT_REVIEW_SUMMARY = '/{store}/{language}/product-review-summary/{productId}';
// product.api.widget
export const PRODUCT_API_WIDGET = '/{store}/{language}/api/product/widget';
// product.api.related_variants
export const PRODUCT_API_RELATED_VARIANTS = '/{store}/{language}/api/related-variants/{variantId}/{productId}';
// product.api.navigation_products
export const PRODUCT_API_NAVIGATION_PRODUCTS = '/{store}/{language}/api/navigation/{navigationId}/products';
// product.api.eans_by_variant
export const PRODUCT_API_EANS_BY_VARIANT = '/{store}/{language}/api/variant/{variantId}/ean';
// product.api.eans_by_variants
export const PRODUCT_API_EANS_BY_VARIANTS = '/{store}/{language}/api/variant-eans';
// product.api.gift_with_purchase
export const PRODUCT_API_GIFT_WITH_PURCHASE = '/{store}/{language}/api/products/{productId}/gift-with-purchase';
// api.shopcart.get
export const API_SHOPCART_GET = '/{store}/{language}/api/shopcart';
// api.shopcart.count
export const API_SHOPCART_COUNT = '/{store}/{language}/api/shopcart/count';
// api.shopcart.product.count
export const API_SHOPCART_PRODUCT_COUNT = '/{store}/{language}/api/shopcart/product/count/{productId}';
// api.shopcart.item.add
export const API_SHOPCART_ITEM_ADD = '/{store}/{language}/api/shopcart/item';
// api.shopcart.item.add.multiple
export const API_SHOPCART_ITEM_ADD_MULTIPLE = '/{store}/{language}/api/shopcart/item/multiple';
// api.shopcart.item.remove
export const API_SHOPCART_ITEM_REMOVE = '/{store}/{language}/api/shopcart/item/{eanId}';
// api.shopcart.item.remove.multiple
export const API_SHOPCART_ITEM_REMOVE_MULTIPLE = '/{store}/{language}/api/shopcart/items';
// api.shopcart.item.update
export const API_SHOPCART_ITEM_UPDATE = '/{store}/{language}/api/shopcart/item/{eanId}';
// api.shopcart.voucher.apply
export const API_SHOPCART_VOUCHER_APPLY = '/{store}/{language}/api/shopcart/voucher/apply';
// api.shopcart.voucher.remove
export const API_SHOPCART_VOUCHER_REMOVE = '/{store}/{language}/api/shopcart/voucher/remove';
// api.checkout.order.get
export const API_CHECKOUT_ORDER_GET = '/{store}/{language}/api/checkout/order';
// api.checkout.address.form
export const API_CHECKOUT_ADDRESS_FORM = '/{store}/{language}/api/checkout/address/form';
// api.checkout.address.save
export const API_CHECKOUT_ADDRESS_SAVE = '/{store}/{language}/api/checkout/address';
// api.checkout.shipping.list
export const API_CHECKOUT_SHIPPING_LIST = '/{store}/{language}/api/checkout/shipping/list';
// api.checkout.shipping.save
export const API_CHECKOUT_SHIPPING_SAVE = '/{store}/{language}/api/checkout/shipping';
// api.checkout.shipping.data.get
export const API_CHECKOUT_SHIPPING_DATA_GET = '/{store}/{language}/api/checkout/shipping/{shippingType}';
// api.checkout.shipping.data.save
export const API_CHECKOUT_SHIPPING_DATA_SAVE = '/{store}/{language}/api/checkout/shipping/{shippingType}';
// api.checkout.payment.list
export const API_CHECKOUT_PAYMENT_LIST = '/{store}/{language}/api/checkout/payment/list';
// api.checkout.payment.save
export const API_CHECKOUT_PAYMENT_SAVE = '/{store}/{language}/api/checkout/payment';
// api.checkout.voucher.apply
export const API_CHECKOUT_VOUCHER_APPLY = '/{store}/{language}/api/checkout/voucher/apply';
// api.checkout.voucher.remove
export const API_CHECKOUT_VOUCHER_REMOVE = '/{store}/{language}/api/checkout/voucher/remove';
// api.checkout.gift_card.apply
export const API_CHECKOUT_GIFT_CARD_APPLY = '/{store}/{language}/api/checkout/gift-card/apply';
// api.checkout.gift_card.remove
export const API_CHECKOUT_GIFT_CARD_REMOVE = '/{store}/{language}/api/checkout/gift-card/remove';
// api.checkout.order.place
export const API_CHECKOUT_ORDER_PLACE = '/{store}/{language}/api/checkout/order/place';
// api.checkout.order.thank
export const API_CHECKOUT_ORDER_THANK = '/{store}/{language}/api/checkout/order/thank';
// api.shopcart.config
export const API_SHOPCART_CONFIG = '/{store}/{language}/api/shopcart/config';
// api.checkout.config
export const API_CHECKOUT_CONFIG = '/{store}/{language}/api/checkout/config';
// api.share_cart.generate_hash
export const API_SHARE_CART_GENERATE_HASH = '/{store}/{language}/api/share-cart/generate-hash';
// api.share_cart.items.add
export const API_SHARE_CART_ITEMS_ADD = '/{store}/{language}/api/share-cart/items';
// api.share_cart.get
export const API_SHARE_CART_GET = '/{store}/{language}/api/share-cart/{hash}';
// api.shopcart.gift_card.apply
export const API_SHOPCART_GIFT_CARD_APPLY = '/{store}/{language}/api/shopcart/gift-card/apply';
// api.shopcart.gift_card.remove
export const API_SHOPCART_GIFT_CARD_REMOVE = '/{store}/{language}/api/shopcart/gift-card/remove';
// api.checkout.payback.payment
export const API_CHECKOUT_PAYBACK_PAYMENT = '/{store}/{language}/api/checkout/payback/payment';
// api.checkout.payback
export const API_CHECKOUT_PAYBACK = '/{store}/{language}/api/checkout/payback/{uuid}';
// api.checkout.order_logger.postback
export const API_CHECKOUT_ORDER_LOGGER_POSTBACK = '/{store}/{language}/api/checkout/order-log';
// api.checkout.payment.flow_exit
export const API_CHECKOUT_PAYMENT_FLOW_EXIT = '/{store}/{language}/api/checkout/payment/flow-exit/{type}';
// checkout.payment.kronor_script
export const CHECKOUT_PAYMENT_KRONOR_SCRIPT = '/checkout/payment/kronor/script';
// api.marketing.subscription
export const API_MARKETING_SUBSCRIPTION = '/{store}/{language}/api/subscription';
// api.marketing.subscription.preferences
export const API_MARKETING_SUBSCRIPTION_PREFERENCES = '/{store}/{language}/api/subscription/preferences';
// api.marketing.newsletter_voucher.displayable
export const API_MARKETING_NEWSLETTER_VOUCHER_DISPLAYABLE = '/{store}/{language}/api/newsletter-voucher/displayable';
// api.recent.product.list
export const API_RECENT_PRODUCT_LIST = '/{store}/{language}/api/me/recent';
// api.recent.product.add
export const API_RECENT_PRODUCT_ADD = '/{store}/{language}/api/me/recent';
// api.recent.search.add
export const API_RECENT_SEARCH_ADD = '/api/recent/search';
// api.recent.searches.get
export const API_RECENT_SEARCHES_GET = '/api/recent/searches';
// api.recent.search.list
export const API_RECENT_SEARCH_LIST = '/api/recent/search/list';
// api.recent.search.remove
export const API_RECENT_SEARCH_REMOVE = '/api/recent/search/remove';
// listing.api.get_listing_by_navigation_id
export const LISTING_API_GET_LISTING_BY_NAVIGATION_ID = '/{store}/{language}/api/navigation/{navigationId}/listing';
// listing.api.get_navigation_product_count
export const LISTING_API_GET_NAVIGATION_PRODUCT_COUNT = '/{store}/{language}/api/navigation-product-count/{navigationId}';
// customer.dashboard
export const CUSTOMER_DASHBOARD = '/{store}/{language}/customer';
// customer.profile
export const CUSTOMER_PROFILE = '/{store}/{language}/customer/profile';
// customer.profile.club
export const CUSTOMER_PROFILE_CLUB = '/{store}/{language}/customer/profile/club';
// customer.profile.club.invoices
export const CUSTOMER_PROFILE_CLUB_INVOICES = '/{store}/{language}/customer/profile/club/invoices';
// customer.profile.email.change.confirm
export const CUSTOMER_PROFILE_EMAIL_CHANGE_CONFIRM = '/{store}/{language}/customer/profile/email/change/confirm/{token}';
// customer.orders
export const CUSTOMER_ORDERS = '/{store}/{language}/customer/orders';
// customer.order
export const CUSTOMER_ORDER = '/{store}/{language}/customer/orders/{id}';
// customer.booztpay
export const CUSTOMER_BOOZTPAY = '/{store}/{language}/customer/booztpay';
// customer.booztpay.invoices
export const CUSTOMER_BOOZTPAY_INVOICES = '/{store}/{language}/customer/booztpay/invoices';
// customer.booztpay.invoice
export const CUSTOMER_BOOZTPAY_INVOICE = '/{store}/{language}/customer/booztpay/invoices/{id}';
// customer.booztpay.account
export const CUSTOMER_BOOZTPAY_ACCOUNT = '/{store}/{language}/customer/booztpay/account';
// customer.booztpay.account.checkout
export const CUSTOMER_BOOZTPAY_ACCOUNT_CHECKOUT = '/{store}/{language}/customer/booztpay/account/checkout';
// customer.booztpay.account.order
export const CUSTOMER_BOOZTPAY_ACCOUNT_ORDER = '/{store}/{language}/customer/booztpay/account/order/{id}';
// customer.booztpay.invoice.checkout
export const CUSTOMER_BOOZTPAY_INVOICE_CHECKOUT = '/{store}/{language}/customer/booztpay/invoices/{id}/checkout';
// customer.order.gift-receipt
export const CUSTOMER_ORDER_GIFT_RECEIPT = '/{store}/{language}/customer/orders/{id}/gift-receipt';
// customer.order.returns
export const CUSTOMER_ORDER_RETURNS = '/{store}/{language}/customer/orders/{id}/returns';
// customer.order.returns_with_source
export const CUSTOMER_ORDER_RETURNS_WITH_SOURCE = '/{store}/{language}/customer/orders/{id}/returns/{source}';
// customer.order.claim
export const CUSTOMER_ORDER_CLAIM = '/{store}/{language}/customer/orders/{id}/claim';
// customer.create
export const CUSTOMER_CREATE = '/{store}/{language}/customer/create';
// customer.login
export const CUSTOMER_LOGIN = '/{store}/{language}/login';
// customer.login-order
export const CUSTOMER_LOGIN_ORDER = '/{store}/{language}/login/order';
// customer.forgot_password
export const CUSTOMER_FORGOT_PASSWORD = '/{store}/{language}/customer/forgot-password';
// customer.reset_password_form
export const CUSTOMER_RESET_PASSWORD_FORM = '/{store}/{language}/customer/reset-password';
// customer.reset_password
export const CUSTOMER_RESET_PASSWORD = '/{store}/{language}/customer/reset-password/{resetToken}';
// customer.email_verification
export const CUSTOMER_EMAIL_VERIFICATION = '/{store}/{language}/customer/email-verification';
// customer.email_verification.verify
export const CUSTOMER_EMAIL_VERIFICATION_VERIFY = '/{store}/{language}/email-verification/verify/{emailVerificationCode}';
// customer.access_elevation
export const CUSTOMER_ACCESS_ELEVATION = '/{store}/{language}/customer/access-elevation';
// customer.voucher_options
export const CUSTOMER_VOUCHER_OPTIONS = '/{store}/{language}/customer/voucher-options';
// customer.returns_list
export const CUSTOMER_RETURNS_LIST = '/{store}/{language}/customer/returns';
// customer.returns_item
export const CUSTOMER_RETURNS_ITEM = '/{store}/{language}/customer/returns/{id}';
// customer.club.sign_up
export const CUSTOMER_CLUB_SIGN_UP = '/{store}/{language}/customer/club/sign-up';
// customer.club
export const CUSTOMER_CLUB = '/{store}/{language}/customer/club';
// customer.club.upgrade
export const CUSTOMER_CLUB_UPGRADE = '/{store}/{language}/customer/club/upgrade';
// customer.club.upgrade.success
export const CUSTOMER_CLUB_UPGRADE_SUCCESS = '/{store}/{language}/customer/club/upgrade/success';
// api.notification_inbox_update
export const API_NOTIFICATION_INBOX_UPDATE = '/{store}/{language}/api/notification-inbox';
// api.review.nps_score_view
export const API_REVIEW_NPS_SCORE_VIEW = '/{store}/{language}/nps/{source}/{score}/{blinkId}/{customerId}/{hash}';
// customer.wallet:
export const CUSTOMER_WALLET = '/{store}/{language}/customer/wallet';
// checkout.share.cart.load
export const CHECKOUT_SHARED_CART = '/{store}/{language}/shared-cart/{hash}';
// api.customer.vouchers
export const API_CUSTOMER_WALLET_VOUCHERS = '/{store}/{language}/api/wallet/vouchers';
// api.customer.wallet.transactions.list
export const API_CUSTOMER_WALLET_TRANSACTIONS = '/{store}/{language}/api/customer/wallet/transactions';
// api.customer.order.get
export const API_CUSTOMER_ORDER = '/{store}/{language}/api/customer/orders/{orderId}';
// gift_shop.listing.get
export const GIFT_SHOP_GET_LISTING_BY_CUSTOMER = '/{store}/{language}/gift-shop/{companySlug}';
// api.gift_shop.listing
export const API_GIFT_SHOP_GET_LISTING_BY_CUSTOMER = '/{store}/{language}/api/gift-shop/listing/{companySlug}';
// api.orders.return.estimation
export const ORDER_RETURN_ESTIMATION = '/{store}/{language}/api/orders/{orderId}/return-estimation';
// api.gift_shop.authenticate.post
export const API_GIFT_SHOP_AUTHENTICATE = '/{store}/{language}/api/gift-shop/authenticate';
// gift_shop.checkout.get
export const GIFT_SHOP_CHECKOUT = '/{store}/{language}/gift-shop/{companySlug}/checkout';
// api.subscription.newsletter.checkout
export const API_SUBSCRIPTION_NEWSLETTER_CHECKOUT = '/{store}/{language}/api/subscription/newsletter/checkout';
// customer.employee.voucher
export const CUSTOMER_EMPLOYEE_VOUCHER = '/{store}/{language}/customer/employee-voucher';
// api.customer.vouchers.add
export const API_CUSTOMER_WALLET_VOUCHERS_ADD = '/{store}/{language}/api/customer/wallet/vouchers';
// product.api.variant_stylitics_account
export const PRODUCT_API_VARIANT_STYLITICS_ACCOUNT = '/{store}/{language}/api/variant-stylitics-accounts/{variantId}';
// product.api.eans_data
export const PRODUCT_API_EANS_DATA = '/{store}/{language}/api/products/{productId}/eans-data';
// api.product.card
export const PRODUCT_API_PRODUCT_CARD = '/{store}/{language}/api/product-cards/{productId}';
// api.product.ean_card
export const PRODUCT_API_PRODUCT_EAN_CARD = '/{store}/{language}/api/product-cards/{productId}/eans/{eanId}';
// api.kindly_chat_feedback
export const API_KINDLY_CHAT_FEEDBACK = '/{store}/{language}/api/kindly-chat-feedback';
// api.customer.login_order
export const API_CUSTOMER_LOGIN_ORDER = '/{store}/{language}/api/login/order';
// marketing.api.subscription.newsletter.discount_code.post
export const MARKETING_API_SUBSCRIPTION_NEWSLETTER = '/{store}/{language}/api/newsletter/official-voucher';
// competition.submit
export const API_SUBMIT_COMPETITION_FORM = '/{store}/{language}/competition/v2/submit';
// api.customer.order_return.config
export const API_CUSTOMER_ORDER_RETURN_CONFIG = '/{store}/{language}/api/customer/returns/config';
// api.customer.account_action.schema
export const API_CUSTOMER_ACCOUNT_ACTION_DATA = '/{store}/{language}/api/customer/account-action/{type}';
